import { Button, Divider } from "@mui/material";
import clsx from "clsx";
import { useState } from "react";
import { createUseStyles } from "react-jss";
import ArrowDownSLineIcon from "remixicon-react/ArrowDownSLineIcon";
import ArrowUpSLineIcon from "remixicon-react/ArrowUpSLineIcon";
import dateformat from "dateformat";
import { theme } from "$utils/theme/bataillog";

import { Text } from "$components";
import { DEFAULT_DATE_FORMAT } from "$utils/utils";
import { useStyles as useEDBProfileClasses } from "$containers/EDB/styles/EdbProfile.Styles";
import { DispositionType } from "$types";
import InformationTable from "./InformationTable";
import { useProfileEDBContext } from "$containers/EDB/ProfileEDB/context/ProfileEDBContext";

function Summary() {
  const classes = useStyles();
  const edbClasses = useEDBProfileClasses();
  const [showDetails, setShowDetails] = useState(false);

  const { edb, idEdb } = useProfileEDBContext();

  const leftTableRows = [
    {
      label: "Nom projet",
      value: edb?.project?.name,
      link: `/edbs/${idEdb}/projets/${edb?.project._id}`,
    },
    {
      label: "Code projet",
      value: edb?.project?.code,
    },
    {
      label: "Nom chantier",
      value: edb?.dockyard?.name,
      link: `/edbs/${idEdb}/chantiers/${edb?.dockyard?._id}`,
    },
    {
      label: "Code chantier",
      value: edb?.dockyard?.code,
    },
    {
      label: "Date validation de l'EDB",
      value:
        edb?.createdAt &&
        dateformat(new Date(edb?.createdAt), DEFAULT_DATE_FORMAT),
    },
  ];

  const rightTableRows = [
    {
      label: "Date de mise à disposition souhaitée",
      value:
        edb?.dispositionDate &&
        dateformat(new Date(edb?.dispositionDate), DEFAULT_DATE_FORMAT),
    },
    {
      label: "Livraison souhaitée",
      value: edb?.dispositionType,
    },
    ...(edb?.dispositionType === DispositionType.SUBCONTRACTED_WAREHOUSE
      ? [
          {
            label: "Nom entrepôt",
            value: edb?.entrepotName || "N/A",
          },
        ]
      : []),
    ...(edb?.dispositionType !== DispositionType.NEAREST_WAREHOUSE
      ? [
          {
            label: "Adresse",
            value: (
              <>
                {edb?.dispositionAdress}
                <br />
                {edb?.dispositionAdress2 && (
                  <>
                    {edb?.dispositionAdress2}
                    <br />
                  </>
                )}
                {edb?.dispositionPostalCode} {edb?.dispositionCity}
                <br />
                {edb?.dispositionCountry}
              </>
            ),
          },
        ]
      : []),
    ...(edb?.analyticCode
      ? [
          {
            label: "Code analytique",
            value: edb.analyticCode,
          },
        ]
      : []),
  ];

  return (
    <>
      <div className={clsx(edbClasses.informations, classes.summary)}>
        <div className={edbClasses.informationsHeader}>
          <Text type="h3" className={edbClasses.informationsTitle}>
            {edb?.company?.name}
          </Text>
          <Button
            className={classes.arrowButton}
            onClick={() => setShowDetails(!showDetails)}
          >
            {showDetails ? <ArrowUpSLineIcon /> : <ArrowDownSLineIcon />}
          </Button>
        </div>
        {showDetails && (
          <div className="about">
            <div className="left">
              <InformationTable rows={leftTableRows} />
            </div>
            <div className="right">
              <InformationTable rows={rightTableRows} />
            </div>
          </div>
        )}
      </div>
      {showDetails && (
        <>
          <Divider className={edbClasses.divider} />
          <div className={edbClasses.informations}>
            <Text type="h3" className={edbClasses.informationsTitle}>
              Notes, contraintes
            </Text>
            <div className="about" style={{ marginTop: 8 }}>
              {edb?.notes || "N/A"}
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Summary;

const useStyles = createUseStyles(() => ({
  summary: {
    background: theme.color.gray1,
    padding: theme.spacing(3),
    borderRadius: 5,
  },
  arrowButton: {
    border: "none !important",
    color: "rgba(0, 0, 0) !important",
    minWidth: "24px !important",
    padding: "8px !important",
    backgroundColor: "transparent !important",
    boxShadow: "none !important",
    "&:hover": {
      color: "rgba(0, 0, 0) !important",
      backgroundColor: "rgba(0, 0, 0, 0.04) !important",
      boxShadow: "none !important",
    },
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.26) !important",
      backgroundColor: "transparent !important",
    },
    "& svg": {
      color: "inherit !important",
    },
  },
}));
